import ONE_APP_USER from "./query.gql";

export interface OneAppUserVariables {
  id: string;
}

export interface BuildingData {
  id: string;
  name: string;
  rooms: RoomData[];
}

export interface RoomData {
  id: string;
  name: string;
}

export interface AppUserData {
  id: string;
  name: string;
  buildings: BuildingData[];
  start: number;
  end: number;
  expired: boolean;
  prePeriod: boolean;
}

export interface OneAppUserData {
  appUser: AppUserData;
}

export { ONE_APP_USER };
